import { LEAD_MAX, LEAD_PRESETS, LEADS_MAX, leadLabel, normalizeLeads } from '../../lib/calendar.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-reminders ---
let __fez_component_0;
{
const UNITS = [
  { value: '1', label: 'minutes' },
  { value: '60', label: 'hours' },
  { value: '1440', label: 'days' },
]
__fez_component_0 = class {
  PROPS = {
    value: Array,
    on_change: Function,
    label: String,
    hint: String,
    error: String,
    disabled: Boolean,
  }

  init() {
    this.state.custom = false
    this.state.customError = ''
    this.state.units = UNITS
  }

  label(minutes) {
    return leadLabel(minutes)
  }

  emit(list) {
    this.props.on_change?.(normalizeLeads(list))
  }

  remove(minutes) {
    this.emit(this.state.leads.filter((lead) => lead !== minutes))
  }

  picked(value) {
    if (value === 'custom') {
      this.state.custom = true
      this.state.customError = ''
      this.setTimeout(() => this.find('.rm-amount input')?.focus(), 30)
    } else if (value !== '') {
      this.emit([...this.state.leads, Number(value)])
    }
  }

  addCustom() {
    const amount = Number(this.find('.rm-amount input')?.value)
    const unit = Number(this.find('.rm-unit select')?.value || 1)
    const minutes = amount * unit
    if (!Number.isInteger(amount) || amount < 0) {
      this.state.customError = 'Enter a whole number.'
    } else if (minutes > LEAD_MAX) {
      this.state.customError = 'Up to 4 weeks before.'
    } else {
      this.state.custom = false
      this.state.customError = ''
      this.emit([...this.state.leads, minutes])
    }
  }

  customKey(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.addCustom()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      event.stopPropagation()
      this.cancelCustom()
    }
  }

  cancelCustom() {
    this.state.custom = false
    this.state.customError = ''
  }

  // The Add list is a menu: it always shows its prompt again.
  afterRender() {
    if (this.state.adder) this.state.adder.value = ''
  }

  beforeRender() {
    const leads = normalizeLeads(this.props.value)
    this.state.leads = leads
    this.state.full = leads.length >= LEADS_MAX
    this.state.presets = LEAD_PRESETS.filter((minutes) => !leads.includes(minutes)).map((minutes) => ({ value: String(minutes), label: leadLabel(minutes) }))
  }

  CSS = `:fez {
display:block;.rm-field{display:grid;gap:6px}.rm-title{font-size:var(--text-sm);font-weight:var(--weight-semibold)}.rm-list{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-2)}.rm-chip{display:inline-flex;align-items:center;gap:var(--space-1);height:30px;padding:0 var(--space-1) 0 var(--space-3);border-radius:var(--radius-full);background:var(--color-accent-soft);color:var(--color-text);font-size:var(--text-sm);font-weight:var(--weight-medium)}.rm-remove{display:inline-grid;place-items:center;width:22px;height:22px;padding:0;border:0;border-radius:var(--radius-full);background:transparent;color:var(--color-text-muted);cursor:pointer;&:hover{background:var(--color-bg-subtle);color:var(--color-text)}&:disabled{cursor:default}}.rm-none{color:var(--color-text-muted);font-size:var(--text-sm)}.rm-add{height:30px;padding:0 var(--space-3);border:1px dashed var(--color-border-strong);border-radius:var(--radius-full);background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-sm);cursor:pointer;&:focus-visible{outline:2px solid var(--color-focus);outline-offset:2px}&:disabled{color:var(--color-text-muted);cursor:default}}.rm-custom{display:flex;flex-wrap:wrap;align-items:end;gap:var(--space-2)}.rm-amount{width:96px}.rm-unit{width:128px}.rm-hint,.rm-error{font-size:var(--text-xs);color:var(--color-text-muted)}.rm-error{color:var(--color-danger)}
}`

  HTML = `<div class="rm-field">
{#if props.label}
<span class="rm-title">{props.label}</span>
{/if}
<div class="rm-list">
{#each state.leads as minutes}
<span class="rm-chip" key={minutes}>
{label(minutes)}
<button class="rm-remove" type="button" title="Remove" aria-label="Remove {label(minutes)}" :disabled="props.disabled" onclick="fez.remove({minutes})"><ui-icon name="x" size="12"></ui-icon></button>
</span>
{/each}
{#if !state.leads.length}
<span class="rm-none">No reminders</span>
{/if}
{#if !state.full}
<select class="rm-add" aria-label="Add a reminder" fez:this="adder" :disabled="props.disabled" onchange="fez.picked(this.value)">
<option value="">Add...</option>
{#each state.presets as preset}
<option value={preset.value}>{preset.label}</option>
{/each}
<option value="custom">Custom...</option>
</select>
{/if}
</div>
{#if state.custom}
<div class="rm-custom" onkeydown="fez.customKey(event)">
<div class="rm-amount"><ui-input type="number" label="Before" value="10"></ui-input></div>
<div class="rm-unit"><ui-select label="Unit" :options="state.units" value="1"></ui-select></div>
<ui-button size="sm" variant="primary" label="Add" onclick="fez.addCustom()"></ui-button>
<ui-button size="sm" variant="ghost" label="Cancel" onclick="fez.cancelCustom()"></ui-button>
</div>
{/if}
{#if state.customError}
<span class="rm-error" role="alert">{state.customError}</span>
{:else if props.error}
<span class="rm-error" role="alert">{props.error}</span>
{:else if props.hint}
<span class="rm-hint">{props.hint}</span>
{/if}
</div>`
};
}

Fez('calendar-reminders', __fez_component_0);

export default __fez_component_0;
